import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Header from "../Presentation/Header/Header";
import {
  getDataForStatistics,
  saveReport,
} from "../../Actions/firebaseActions";
import LastPurchase from "../Presentation/Reports/LastPurchase";
import LastWeek from "../Presentation/Reports/LastWeek";
import LastMonth from "../Presentation/Reports/LastMonth";
import WholeSection from "../Presentation/Reports/WholeSection";
import ReportPicker from "../Presentation/Reports/ReportPicker";

let langData = require("../../Data/language.json");

const ReportScreen = (props) => {
  const [currentReport, setCurrentReport] = useState("all");
  const [dataLoaded, setDataLoaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingStatus, setLoadingStatus] = useState("loading data...");
  const [inventory, setInventory] = useState([]);

  const [trash, setTrash] = useState([]);

  let reportContent = (
    <LastPurchase
      inventory={inventory}
      trash={trash}
      languageData={langData[props.language]}
    />
  );

  if (currentReport === "purchase") {
    reportContent = (
      <LastPurchase
        inventory={inventory}
        trash={trash}
        languageData={langData[props.language]}
      />
    );
  } else if (currentReport === "week") {
    reportContent = (
      <LastWeek
        inventory={inventory}
        trash={trash}
        languageData={langData[props.language]}
      />
    );
  } else if (currentReport === "month") {
    reportContent = (
      <LastMonth
        inventory={inventory}
        trash={trash}
        languageData={langData[props.language]}
      />
    );
  } else if (currentReport === "all") {
    reportContent = (
      <WholeSection
        inventory={inventory}
        trash={trash}
        languageData={langData[props.language]}
      />
    );
  }

  useEffect(() => {
    /* DOES INITIAL LOAD OF CURRENT DATA FROM DATABASE */
    props.getDataForStatistics(props.username);
    setDataLoaded(true);
  }, []);

  useEffect(() => {
    /* LOADS DATA INTO TWO SEPARATE ARRAYS FOR EASIER HANDLING */
    if (props.reportData !== {} && dataLoaded) {
      let tempInventory = [];
      let tempTrash = [];
      Object.keys(props.reportData["inventory"]).forEach((elem) => {
        tempInventory.push(props.reportData["inventory"][elem]);
      });
      Object.keys(props.reportData["trash"]).forEach((elem) => {
        tempTrash.push(props.reportData["trash"][elem]);
      });

      setInventory(tempInventory);
      setTrash(tempTrash);
      setLoading(false);
      setLoadingStatus("Generating Report...");
    }
  }, [props.reportData]);

  return (
    <div>
      <Header
        currentUser={props.username}
        language={props.language}
        showBackBtn={true}
        onBackClick={() => props.history.goBack()}
      />
      <ReportPicker
        currentReport={currentReport}
        setReport={setCurrentReport}
      />

      {loading ? (
        <p style={{ marginTop: "70px" }}>{loadingStatus}</p>
      ) : (
        reportContent
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  username: state.firebase.username,
  reportData: state.firebase.reportData,
  language: state.firebase.language,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getDataForStatistics: (username) =>
      dispatch(getDataForStatistics(username)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReportScreen)
);
